import React from 'react';

const IconClose = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4199 16L25.9546 8.46533C26.1032 8.31676 26.2212 8.14037 26.3017 7.94622C26.3821 7.75207 26.4236 7.54397 26.4237 7.3338C26.4237 7.12363 26.3824 6.91551 26.302 6.72131C26.2216 6.52711 26.1038 6.35065 25.9552 6.202C25.8067 6.05334 25.6303 5.9354 25.4361 5.85492C25.242 5.77443 25.0339 5.73297 24.8237 5.73291C24.6135 5.73285 24.4054 5.77418 24.2112 5.85455C24.017 5.93493 23.8406 6.05276 23.6919 6.20133L16.1572 13.7373L8.62124 6.20133C8.31772 5.91783 7.91592 5.76335 7.50065 5.77049C7.08539 5.77763 6.68914 5.94584 6.39554 6.23961C6.10195 6.53338 5.93398 6.92972 5.92708 7.34499C5.92018 7.76027 6.0749 8.16197 6.35858 8.46533L13.8946 16L6.35858 23.5347C6.13585 23.7589 5.98442 24.044 5.92331 24.3541C5.8622 24.6642 5.89415 24.9855 6.01513 25.2775C6.13612 25.5695 6.34075 25.8192 6.60327 25.9952C6.8658 26.1712 7.17451 26.2656 7.49058 26.2667C7.89991 26.2667 8.30924 26.1107 8.62124 25.7987L16.1572 18.2627L23.6919 25.7987C23.8403 25.9475 24.0166 26.0657 24.2108 26.1463C24.4049 26.2269 24.613 26.2684 24.8232 26.2684C25.0334 26.2684 25.2416 26.2269 25.4357 26.1463C25.6299 26.0657 25.8062 25.9475 25.9546 25.7987C26.1033 25.6501 26.2214 25.4736 26.3019 25.2794C26.3824 25.0851 26.4238 24.8769 26.4238 24.6667C26.4238 24.4564 26.3824 24.2482 26.3019 24.054C26.2214 23.8597 26.1033 23.6833 25.9546 23.5347L18.4199 16Z"
        fill="currentColor"
      />
    </svg>
  );
};

const MemoIconClose = React.memo(IconClose);
export default MemoIconClose;
